import Vue from 'vue';
// eslint-disable-next-line
export const doorlocksEventBus = new Vue();



// WEBPACK FOOTER //
// ./src/components/admin/doorlocks/doorlocksEventBus.js